import Blue from '~/core'
import SwiperJS, { Navigation, Pagination } from 'swiper'
SwiperJS.use([Navigation, Pagination])

new Blue({
  name: 'Decade Carousel',
  selector: '.decade',
  setup(container) {
    console.log('here')
    const carousel = container.querySelector('.decade__carousel')
    const wrapper = container.querySelector('.decade__wrapper')
    const slides = [...container.querySelectorAll('.decade__slide')]
    const prevEl = container.querySelector('button.decade__prev')
    const nextEl = container.querySelector('button.decade__next')
    const navigation = container.querySelector('.decade__navigation')
    const pagination = container.querySelector('.decade__pagination')
    const random = Math.ceil(Math.random() * 10000)
    carousel.classList.add('swiper')
    carousel.classList.add('swiper-' + random)
    wrapper.classList.add('swiper-wrapper')
    slides.forEach((slide) => slide.classList.add('swiper-slide'))
    pagination.classList.add('swiper-pagination')
    pagination.classList.add('swiper-pagination-' + random)

    console.log(slides.length)
    if (slides.length > 1) {
      const swiper = new SwiperJS('.swiper-' + random, {
        loop: true,
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: pagination,
          type: 'custom',
          renderCustom: (swiper, current, total) => {
            return (
              '<span class="swiper-pagination-current">' +
              current +
              '</span> <span class="decade__of">of</span> <span class="swiper-pagination-total">' +
              total +
              '</span>'
            )
          },
        },
      })
    }
  },
})
